import { NavLink } from "react-router-dom";

const DynamicFilledButton = (props) => {
    return (
        props.href
            ? <NavLink
                className="DynamicFilledButton_control"
                aria-label={props.text}
                to={props.href}
                onClick={props.onClick}
                style={{ ...props.styles }}>
                {props.text}
            </NavLink>
            : <button
                className="DynamicFilledButton_control"
                aria-label={props.text}
                onClick={props.onClick}
                style={{ ...props.styles }}>
                {props.text}
            </button>
    )
}

export default DynamicFilledButton;